
import { formatPrice } from "@decocms/apps-commerce/sdk/formatPrice"
import { useCart } from "~/hooks/useCart"
import { FreeShippingSectionProps } from "~/sections/Content/FreeShipping"
import { useMemo } from "react"
import clsx from "~/sdk/clx"

const calculateMissingValue = (freeShippingValue: number, total: number, discounts: number) =>
    freeShippingValue - (total + discounts) / 100

const calculateValuePercentage = (freeShippingValue: number, missingValue: number) =>
    missingValue <= 0 ? 100 : ((freeShippingValue - missingValue) / freeShippingValue) * 100

const FreeShipping = (
    { freeShippingValue, layout = 'header' }: FreeShippingSectionProps,
) => {
    const { cart } = useCart()
    const total = cart?.value?.totalizers.find((item) => item.id === 'Items')?.value ?? 0
    const discounts = cart?.value?.totalizers?.find((item) => item.id === 'Discounts')?.value || 0

    const missingValue = useMemo(() => calculateMissingValue(freeShippingValue, total, discounts), [
        freeShippingValue,
        total,
        discounts,
    ])
    const valuePercentage = useMemo(
        () => calculateValuePercentage(freeShippingValue, missingValue),
        [freeShippingValue, missingValue],
    )

    return (
        <div className='relative w-full bg-bege-light text-wine h-[35px] block'>
            <div
                className='h-[35px] bg-bege transition-all duration-[2000ms]'
                style={{ width: `${valuePercentage}%` }}
            >
                <div
                    style={{
                        backgroundImage: `url(${'/bg-effect.png'})`,
                        backgroundPosition: 'center',
                        backgroundRepeat: 'repeat-x',
                    }}
                    className='w-full h-full'
                />
            </div>
            {cart?.value && (
                <div
                    className={clsx(
                        'absolute inset-0 flex items-center text-sm justify-center gap-x-2 text-center',
                        layout === 'header' && ' md:text-base',
                    )}
                >
                    {missingValue <= 0
                        ? (
                            <span>
                                Parabéns, você ganhou{' '}
                                <span className='uppercase font-black'>Frete Grátis!</span>{' '}
                                para o Brasil.
                            </span>
                        )
                        : (
                            <span>
                                Faltam{' '}
                                <span className='uppercase font-black'>
                                    {formatPrice(missingValue)}
                                </span>{' '}
                                para você ganhar{' '}
                                <span className='uppercase font-black'>Frete Grátis!</span>
                            </span>
                        )}
                </div>
            )}
        </div>
    )
}

export default FreeShipping
